export function searchFilter<D>({
  data,
  filters = [],
  search
}: {
  filters?: ((data: D) => string | unknown)[]
  data: D[]
  search: string
}): D[] {
  if (!data.length) return []

  filters.forEach((filter) => {
    if (typeof filter(data[0]) !== 'string') {
      throw new Error(
        `search filter failed in ${JSON.stringify(
          data?.[0]
        )} is not a string type`
      )
    }
  })

  const filteredData = data.filter((item) => {
    const combinedItem = filters
      ?.map((filter) => filter(item) as string)
      .join(' ')
    if (!search) return true

    const names = combinedItem
      .toLocaleLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .split(' ')
    const searchs = search
      .toLocaleLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .split(' ')

    return searchs.every((search) =>
      names.find((name) => name.startsWith(search.trim().toLocaleLowerCase()))
    )
  })

  return filteredData
}
